module.exports = __webpack_public_path__ + "media/images/flags/1x1/gnb-bc458bf235d2005751be21e2ec7711f8.svg";